export default {
    LOADING: 'loading',
    REJECTION_RESTRICTED_APPROVAL: 'rejection_restricted_approval',
    REJECTION_RESTRICTED_APPROVED_FEEDBACK: 'rejection_restricted_approved_feedback',
    REJECTION_RESTRICTED_DND_FEEDBACK: 'rejection_restricted_dnd_feedback',
    EMPTY: 'empty',
    DO: 'do',
    DO_NOT: 'doNot',
    MISSED: 'missed',
    NONE_MISSED: 'none_missed',
    RATE_CONTENT: 'rate_content',
    DO_NOT_DISTRIBUTE: 'do_not_distribute',
    MISSED_AND_APPROVED: 'missed_and_approved',
    REJECTING: 'rejecting'
};



// WEBPACK FOOTER //
// ./components/content_review_workflow/states.js